import { render } from "./shopOrderCompleted.vue?vue&type=template&id=6606f9ec&scoped=true"
import script from "./shopOrderCompleted.vue?vue&type=script&lang=js"
export * from "./shopOrderCompleted.vue?vue&type=script&lang=js"

import "./shopOrderCompleted.vue?vue&type=style&index=0&id=6606f9ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6606f9ec"]])

export default __exports__